import React, { useState, useEffect } from 'react';
import { Select, Divider, Form, Modal, Row, Col, Input, Skeleton, Button, Icon, Table, message } from 'antd';
import CustomAvatar from './../components/customAvatar';
import Flag from "react-country-flags";
import { allNations } from './../utils/countries';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { getClients, createClient } from './../API';
import { modalDiv, flexCenterRight, formItemLayout } from './../theme';
import { navigate } from "@reach/router"
import { refGenerator } from './../utils';

const { Search, TextArea } = Input;
const { Option } = Select;

function Clients({form}) {
  const nations = allNations();
  const { getFieldDecorator } = form;

  const session = useMappedState(state => state.session);
  const clients = useMappedState(state => state.clients);

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [createLoading, setCreateLoading] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      const response = await getClients(session.authToken);
      dispatch({type: "INIT_CLIENTS", payload: response.data.clients});
      setLoading(false);
    }
    dispatch({type: "SET_INDEX", payload: "3"});
    fetchData();
  // eslint-disable-next-line
  }, []);

  const showAvatar = (contacts) => {
    return(
      contacts.map(i =>
        <div key={i.id} style={{cursor: 'pointer'}} onClick={() => {
          navigate(`/contacts/${i.id}`)
        }}>
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={`${i.firstname} ${i.lastname}`}
            style={{
              marginLeft: "-15px",
              position: "relative",
              border: "1px solid #fff",
              overflow: "hidden",
            }}
            colourCode={i.firstname.charAt(0).toLowerCase()}
            char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            src={i.avatar} 
          />
        </div>)
    )
  }

  const handleCreateNewClient = async () => {
    const formResult = await form.validateFields();
    setCreateLoading(true);
    const requestData = {
      reference: refGenerator('client', clients.length),
      name: formResult.name.trim(),
      invoiceClientName: formResult.invoiceClientName ? formResult.invoiceClientName.trim() : formResult.invoiceClientName,
      tel: formResult.landline,
      website: formResult.website,
      jobs: formResult.jobs,
      tob: formResult.tob,
      address: {
        address1: formResult.address1,
        address2: formResult.address2,
        city: formResult.city,
        country: formResult.country,
        postcode: formResult.postcode
      },
      invoiceAddress: {
        address1: formResult.invoiceAddress1,
        address2: formResult.invoiceAddress2,
        city: formResult.invoiceCity,
        country: formResult.invoiceCountry,
        postcode: formResult.invoicePostcode
      }
    }

    const result = await createClient(session.authToken, requestData);

    if (result.data.responseCode === 0) {
      const response = await getClients(session.authToken);
      dispatch({type: "INIT_CLIENTS", payload: response.data.clients});
      setCreateLoading(false);
      setShowModal(false);
      form.resetFields();
      message.success(result.data.message);
    }
    else {
      setCreateLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
    }

  }

  const columns = [
    {
      title: '',
      width: '1%',
      key: 'avatar',
      render: (client) =>
      <CustomAvatar
        colourCode={client.name.charAt(0).toLowerCase()}
        char={`${client.name.charAt(0).toUpperCase()}`}
        charSize={12}
        src={client.avatar} 
      />
    },
    {
      title: 'Name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      width: '8%',
      dataIndex: 'name',
      key: 'name',
    },
    // {
    //   title: 'Country',
    //   width: '7%',
    //   dataIndex: 'country',
    //   sorter: (a, b) => a.reference.localeCompare(b.country),
    //   key: 'country',
    // },
    {
      title: 'City',
      sorter: (a, b) => a.address.city.localeCompare(b.address.city),
      width: '6%',
      dataIndex: 'address',
      key: 'address',
      render: address => <span>{address.city}</span>
    },
    {
      title: 'Contacts',
      width: '10%',
      dataIndex: 'contacts',
      key: 'contacts',
      render: (contacts) => {
        return(
          <div style={{
            display: 'inline-flex',
            flexDirection: 'row-reverse'
          }}>
            {showAvatar(contacts)}
          </div>
        )
      }
    },
    {
      title: '',
      width: '5%',
      render: (client) => <div style={flexCenterRight}>
        <Button 
          disabled={!client.website || client.webiste === ""} 
          size="small" 
          onClick={() => {
            if (client.website && client.webiste !== "") {
              window.open(client.website, '_blank');
            }
            else {
              dispatch({type: "OPEN_MSG_MODAL", payload: "website is not available"});
            }
          }}
        >
          <Icon type="link" /> Website
        </Button>
        &nbsp;&nbsp;
        <Button 
          disabled={!client.jobs || client.jobs === ""} 
          size="small" 
          onClick={() => {
            if (client.jobs && client.jobs !== "") {
              window.open(client.jobs, '_blank');
            }
            else {
              dispatch({type: "OPEN_MSG_MODAL", payload: "jobs website is not available"});
            }
          }}
        >
          <Icon type="link" /> Jobs
        </Button>
        &nbsp;&nbsp;
        <Button size="small" onClick={() => {
          navigate(`/clients/${client.id}`)
        }}><Icon type="plus" /> Details</Button>
      </div>
    }
  ];

  const countrySelection = [];
  for (let i = 0; i < nations.length; i++) {
    countrySelection.push(
      <Option key={i} value={nations[i].name} label={nations[i].name}>
        <Row>
          <Col span={4}>
            <Flag country={nations[i].code} asSquare={true} style={{width: '30px', height: '20px'}}/>
          </Col>
          <Col>
            {nations[i].name}
          </Col>
        </Row>
      </Option>
    )
  }

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <React.Fragment>
      {/* this modal serve create new client */}
      <Modal
        centered={true}
        title="Create New Client"
        closable={false}
        visible={showModal}
        width="90%"
        footer={[
          <Button
            disabled={createLoading}
            key="cancel" 
            onClick={() => {
              setShowModal(false);
              form.resetFields();
            }}
          >
            <Icon type="close" />
            Cancel
          </Button>,
          <Button key="create" type="primary" onClick={handleCreateNewClient}>
            {createLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Create
          </Button>
        ]}
      >
        <div style={modalDiv}>
          <Form>
            <Row>
              <Col span={12}>
                <div style={{marginRight: '10px'}}>
                  <Form.Item {...formItemLayout} label="Name">
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: 'Please input name!' }],
                    })(
                      <Input autoComplete="off" placeholder="Name" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Landline">
                    {getFieldDecorator('landline', {})(
                      <Input autoComplete="off" placeholder="Landline" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Website">
                    {getFieldDecorator('website', {})(
                      <Input autoComplete="off" placeholder="Website" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Jobs Website">
                    {getFieldDecorator('jobs', {})(
                      <Input autoComplete="off" placeholder="Jobs Website" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Term">
                    {getFieldDecorator('tob', {})(
                      <TextArea rows={4} placeholder="Term of Business" disabled={createLoading} />
                    )}
                  </Form.Item>

                </div>
              </Col>
              <Col span={12}>
                <div style={{marginLeft: '10px'}}>
                  <Form.Item {...formItemLayout} label="Address 1">
                    {getFieldDecorator('address1', {})(
                      <Input autoComplete="off" placeholder="Address 1" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Address 2">
                    {getFieldDecorator('address2', {})(
                      <Input autoComplete="off" placeholder="Address 2" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="City">
                    {getFieldDecorator('city', {
                      rules: [{ required: true, message: 'Please input city!' }],
                    })(
                      <Input autoComplete="off" placeholder="City" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Country">
                    {getFieldDecorator('country', {})(
                      <Select
                        disabled={createLoading}
                        placeholder="Country"
                        optionLabelProp="label"
                        showSearch
                      >
                      {countrySelection}
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Post Code">
                    {getFieldDecorator('postcode', {})(
                      <Input autoComplete="off" placeholder="Post Code" disabled={createLoading} />
                    )}
                  </Form.Item>

                </div>
              </Col>
            </Row>
            <Divider />

            <div><b>Invoice Address</b></div><br/>
            
            <Row>
              <Col span={12}>
                <div style={{marginRight: '10px'}}>
                  <Form.Item {...formItemLayout} label="Client Name">
                    {getFieldDecorator('invoiceClientName', {})(
                      <Input autoComplete="off" placeholder="Client Name" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="City">
                    {getFieldDecorator('invoiceCity', {})(
                      <Input autoComplete="off" placeholder="City" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Country">
                    {getFieldDecorator('invoiceCountry', {})(
                      <Select
                        disabled={createLoading}
                        placeholder="Country"
                        optionLabelProp="label"
                        showSearch
                      >
                      {countrySelection}
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div style={{marginLeft: '10px'}}>
                  <Form.Item {...formItemLayout} label="Address 1">
                    {getFieldDecorator('invoiceAddress1', {})(
                      <Input autoComplete="off" placeholder="Address 1" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Address 2">
                    {getFieldDecorator('invoiceAddress2', {})(
                      <Input autoComplete="off" placeholder="Address 2" disabled={createLoading} />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="Post Code">
                    {getFieldDecorator('invoicePostcode', {})(
                      <Input autoComplete="off" placeholder="Post Code" disabled={createLoading} />
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>

          </Form>
        </div>
      </Modal>

      <Row>
        <Col span={12}>
          <Search
            placeholder="Search"
            onChange={e => setSearch(e.target.value)}
            style={{ width: 200 }}
          />
        </Col>
        <Col span={12}>
          <div style={flexCenterRight}>
            <Button type="primary" onClick={() => {
              setShowModal(true);
            }}><Icon type="plus-square" /> New Client</Button>
          </div>
        </Col>
      </Row>

      <br/>
      <Table
        columns={columns}
        dataSource={search === "" ?
          clients
          :
          clients.filter(i =>
            i.contacts.map(k => {return `${k.firstname} ${k.lastname}`}).join().toLowerCase().includes(search.toLowerCase()) ||
            i.name.toLowerCase().includes(search.toLowerCase()) ||
            i.address.city.toLowerCase().includes(search.toLowerCase())
          )}
        rowKey="id"
      />
    </React.Fragment>
  );
}

const ClientsForm = Form.create({ name: 'clients' })(Clients);

export default ClientsForm;
